"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var sidebar_component_1 = require("./sidebar.component");
var CloseSidebar = (function () {
    function CloseSidebar(_sidebar) {
        this._sidebar = _sidebar;
    }
    /** @internal */
    CloseSidebar.prototype._onClick = function () {
        if (this._sidebar) {
            this._sidebar.close();
        }
    };
    return CloseSidebar;
}());
CloseSidebar.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[closeSidebar]',
                host: {
                    '(click)': '_onClick()'
                }
            },] },
];
/** @nocollapse */
CloseSidebar.ctorParameters = function () { return [
    { type: sidebar_component_1.Sidebar, },
]; };
exports.CloseSidebar = CloseSidebar;



//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/ng-sidebar/lib/close.directive.js
// module id = ../../../../ng-sidebar/lib/close.directive.js
// module chunks = 9